import { render, staticRenderFns } from "./inventory-lot-show.html?vue&type=template&id=41871e24&scoped=true&"
import script from "./inventory-lot-show.ts?vue&type=script&lang=js&"
export * from "./inventory-lot-show.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41871e24",
  null
  
)

export default component.exports